import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ServerInferRequest } from "@ts-rest/core";
import { isAxiosError } from "axios";
import { manualTransactionContract } from "@common/contracts/manual-transaction.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { useToaster } from "@design-system/ToastMessages/useToaster";

const manualTransactionContractClient = getBackendAPIClient(
    manualTransactionContract,
);

export function useTransactionsCreation() {
    const queryClient = useQueryClient();
    const { error } = useToaster();

    return useMutation({
        mutationFn: async (
            data: ServerInferRequest<
                typeof manualTransactionContract.createManualTransactions
            >["body"],
        ) => {
            const response =
                await manualTransactionContractClient.createManualTransactions({
                    body: data,
                });

            if (
                response.body.transactions.length !== data.transactions.length
            ) {
                throw new Error("Not all transactions were created");
            }

            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
        onError: (mutationError) => {
            const hasBackendErrorToast =
                isAxiosError<{ message?: string | string[] }>(mutationError) &&
                Boolean(mutationError.response?.data.message);

            if (!hasBackendErrorToast) {
                error("Failed to add transactions");
            }
        },
    });
}
